import { describeRule } from './describe';
import type { RuleHash } from './rule';

const CURRENT_OPTION = 'option[data-recurring-schedule-role="current"]';

export function writePreset(select: HTMLSelectElement, rule: RuleHash): string {
  const json = JSON.stringify(rule);
  const label = describeRule(rule);
  const current = select.querySelector<HTMLOptionElement>(CURRENT_OPTION);

  if (current) {
    current.value = json;
    current.textContent = label;
    return json;
  }

  const option = document.createElement('option');
  option.value = json;
  option.textContent = label;
  option.dataset.recurringScheduleRole = 'current';
  select.insertBefore(option, select.querySelector<HTMLOptionElement>('option[value="custom"]'));

  return json;
}
